export default __webpack_public_path__ + "static/media/iconPlus.d65876af.svg";